// src/store/modules/geojson.js

export default {
    namespaced: true,

    state: {
        geojsonData: null,
        loading: false,
        error: null,
        filters: {
            category: null,
            zone: null,
            dimensions: null,
            owner: null,
            soldStatus: null
        }
    },

    mutations: {
        SET_GEOJSON_DATA(state, data) {
            state.geojsonData = data;
        },
        SET_LOADING(state, status) {
            state.loading = status;
        },
        SET_ERROR(state, error) {
            state.error = error;
        },
        UPDATE_FILTER(state, { filterType, value }) {
            state.filters[filterType] = value;
        },
        RESET_FILTERS(state) {
            Object.keys(state.filters).forEach(key => {
                state.filters[key] = null;
            });
        }
    },

    actions: {
        async loadGeoJSONData({ commit }) {
            commit('SET_LOADING', true);
            try {
                const response = await fetch('data/silvercity/plots.geojson');
                const data = await response.json();
                commit('SET_GEOJSON_DATA', data);
            } catch (error) {
                commit('SET_ERROR', error.message);
            } finally {
                commit('SET_LOADING', false);
            }
        },

        updateFilter({ commit }, payload) {
            commit('UPDATE_FILTER', payload);
        },

        resetFilters({ commit }) {
            commit('RESET_FILTERS');
        }
    },

    getters: {
        filteredGeoJSON: (state, getters) => {
            return {
                type: 'FeatureCollection',
                features: getters.filteredFeatures || []
            };
        },
        
        // Update the existing filteredFeatures getter to handle null state
        filteredFeatures: state => {
            if (!state.geojsonData || !state.geojsonData.features) return [];
    
            return state.geojsonData.features.filter(feature => {
                const props = feature.properties;
                return Object.entries(state.filters).every(([key, value]) => {
                    if (!value) return true; // Skip empty filters
                    
                    switch(key) {
                        case 'category': return props.Category === value;
                        case 'zone': return props.Zone === value;
                        case 'dimensions': return props.Dimensions === value;
                        case 'owner': return props.Type === value;
                        case 'soldStatus': return props.SoldStatus === value;
                        default: return true;
                    }
                });
            });
        }, 

        filteredFeaturesExcept: (state) => (excludeFilter) => {
            if (!state.geojsonData?.features) return [];
            
            return state.geojsonData.features.filter(feature => {
                const props = feature.properties;
                return Object.entries(state.filters).every(([key, value]) => {
                    // Skip the filter we're currently populating and empty filters
                    if (key === excludeFilter || !value) return true;
                    
                    switch(key) {
                        case 'category': return props.Category === value;
                        case 'zone': return props.Zone === value;
                        case 'dimensions': return props.Dimensions === value;
                        case 'type': return props.Type === value;
                        case 'soldStatus': return props.SoldStatus === value;
                        default: return true;
                    }
                });
            });
        },
    
        // Update each options getter to respect other filters
        categoryOptions: (state, getters) => {
            const features = getters.filteredFeaturesExcept('category');
            return [...new Set(features
                .map(f => f.properties.Category)
                .filter(Boolean))]
                .sort();
        },
    
        zoneOptions: (state, getters) => {
            const features = getters.filteredFeaturesExcept('zone');
            return [...new Set(features
                .map(f => f.properties.Zone)
                .filter(Boolean))]
                .sort();
        },
    
        dimensionOptions: (state, getters) => {
            const features = getters.filteredFeaturesExcept('dimensions');
            return [...new Set(features
                .map(f => f.properties.Dimensions)
                .filter(Boolean))]
                .sort();
        },
    
        ownerOptions: (state, getters) => {
            const features = getters.filteredFeaturesExcept('type');
            return [...new Set(features
                .map(f => f.properties.Type)
                .filter(Boolean))]
                .sort();
        },
    
        soldStatusOptions: (state, getters) => {
            const features = getters.filteredFeaturesExcept('soldStatus');
            return [...new Set(features
                .map(f => f.properties.SoldStatus)
                .filter(Boolean))]
                .sort();
        },
        

        

        

        

        filteredZoneStatistics: (state, getters) => {
            if (!getters.filteredFeatures.length) return null;
            
            const stats = {};
            getters.filteredFeatures.forEach(feature => {
                const props = feature.properties;
                const zone = props.Zone;
                
                if (!zone) return;
                
                if (!stats[zone]) {
                    stats[zone] = {
                        total: 0,
                        sold: 0,
                        uniqueOwners: new Set()
                    };
                }
                
                stats[zone].total++;
                if (props.SoldStatus === 'Sold') {
                    stats[zone].sold++;
                }
                if (props.J_Owner) {
                    stats[zone].uniqueOwners.add(props.J_Owner);
                }
            });

            // Convert Sets to numbers
            Object.keys(stats).forEach(zone => {
                stats[zone].uniqueOwners = stats[zone].uniqueOwners.size;
            });

            return stats;
        }
    }
};